export default __webpack_public_path__ + "static/media/clear.5a3faac2.svg";